var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[(!_vm.authError)?_c('Loader'):_c('div',{staticClass:"text-danger",staticStyle:{"font-size":"35px","position":"relative","top":"20px"}},[_c('i',{staticClass:"fas fa-times"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }